import { makeStyles, } from '@material-ui/core/styles';

import { doveGray, } from 'styles/abstract/variables';

export const makeCookiePanelStyles = makeStyles({
    container: {
        background: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'auto',
        width: '100%',
        position: 'fixed',
        color: doveGray,
        fontSize: '1rem',
        boxShadow: '0 0 3px 1px rgb(0 0 0 / 20%)',
        textAlign: 'center',
    },

    infoLinkLabel: {
        fontWeight: 600,
    },

    button: {
        padding: 8,
        marginLeft: 20,
    }
});
